/* tslint:disable */
/* eslint-disable */
export enum EnumProvider {
  Octopus = 0,
  Office365 = 1,
  Microsoft = 2,
  Google = 3,
  LinkedIn = 4
}
